import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const tabGroupDefinition: ComponentDefinition = {
  id: 'tabGroup',
  name: 'Tab Section - Group',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/columns-2.svg',
  children: true,
  variables: {
    title: {
      type: 'Text',
      displayName: 'Title',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    icon: {
      type: 'Media',
      displayName: 'Icon (SVG)',
      validations: { bindingSourceType: ['asset'] },
    },
  },
} as const;
